import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

export const StyledFormCheck = styled(Form.Check)<{ type: 'checkbox' | 'radio' }>`
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: ${({ theme, type }) =>
      type === 'checkbox' ? theme.components.checkBoxes.borderColor.selected : theme.components.radioButtons.borderColor.selected};
    border-width: 2px;
    background-color: ${({ theme, type }) =>
      type === 'checkbox' ? theme.components.checkBoxes.backgroundColor.selected : theme.components.radioButtons.backgroundColor.selected};
  }

  .custom-control-input:checked ~ .custom-control-label::after {
    content: '';
    background-image: ${({ type, theme }) => {
      const fillColor = (type === 'checkbox' ? theme.components.checkBoxes.color.selected : theme.components.radioButtons.color.selected).replace(
        '#',
        ''
      );
      const svgUrl =
        type === 'checkbox'
          ? `url("data:image/svg+xml,<svg width='20' height='20' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><path fill-rule='evenodd' clip-rule='evenodd' d='M13.1854 0.6125C13.3381 0.7625 13.3381 0.9875 13.1854 1.1375L4.78541 9.3875C4.70904 9.4625 4.61359 9.5 4.51813 9.5C4.42268 9.5 4.32722 9.4625 4.25086 9.3875L0.814497 6.0125C0.661769 5.8625 0.661769 5.6375 0.814497 5.4875C0.967224 5.3375 1.19631 5.3375 1.34904 5.4875L4.51813 8.6L12.6509 0.6125C12.8036 0.4625 13.0327 0.4625 13.1854 0.6125Z' fill='%23${fillColor}' stroke='%23${fillColor}' stroke-width='2.5625' /></svg>")`
          : `url("data:image/svg+xml,%3Csvg height='100' width='100' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle r='45' cx='50' cy='50' fill='%23${fillColor}' /%3E%3C/svg%3E")`;
      return svgUrl;
    }};
    border-color: ${({ theme, type }) => theme.colors[type === 'checkbox' ? 'lightMint' : 'brightGreen']};
  }

  /* Styles for unchecked state */
  .custom-control-input:not(:checked) ~ .custom-control-label::before {
    /* Define your styles for unchecked state here */
    border-color: ${({ theme, type }) =>
      type === 'checkbox' ? theme.components.checkBoxes.borderColor.unselected : theme.components.radioButtons.borderColor.unselected};
    background-color: ${({ theme, type }) =>
      type === 'checkbox' ? theme.components.checkBoxes.backgroundColor.unselected : theme.components.radioButtons.backgroundColor.unselected};
  }
`;
